import {   
REQUEST_LOANS,
RECEIVE_LOANS_SUCCESS,
REQUEST_LOANREPORT,
RECEIVE_LOANREPORT_SUCCESS,
RECEIVE_LOANS_ERROR,
REQUEST_LOANS_SAVE,
RECEIVE_LOANS_SAVE_ERROR,
RECEIVE_LOANS_SAVE_SUCCESS,
REQUEST_LOANS_REMOVE,
RECEIVE_LOANS_REMOVE_SUCCESS,


        }  from '../actions/loans'

const DEFAULT_LOANS=   {
    isFetching: true,
    isReportFetching: true,
    loans: [], 
    report: {}
};

export function loans (state = DEFAULT_LOANS, action) {
    
    switch (action.type) {

        case REQUEST_LOANS: {
            var newstate = {
                ...state,
                loans: [...state.loans],  
                report: {...state.report},
                isFetching: true
            };
            return newstate;
        }

        case RECEIVE_LOANS_SUCCESS: {
            var newstate = {
                ...state,   
                loans: [...action.loans],
                report: {...state.report},
                isFetching: false,
                 }
            return newstate;            
        }

        case REQUEST_LOANREPORT: {
            var newstate = {
                ...state,
                loans: [...state.loans],  
                report: {...state.report},
                isReportFetching: true,
            };
            return newstate;
        }

        case RECEIVE_LOANREPORT_SUCCESS: {
            var newstate = {
                ...state,   
                loans: [...state.loans],
                report: {...action.report},
                isReportFetching: false
                 }
            return newstate;            
        }

        case REQUEST_LOANS_SAVE: {

       
            let newState = 
                {...state,
                    loans: [...state.loans],
                    report: {...state.report},
                    isFetching: true}                 
            return newState;
        }

        case RECEIVE_LOANS_SAVE_SUCCESS:  {      
            let newState = 
            {...state,
            loans: [...state.loans, action.loan],
            report: {...state.report},
            isFetching: false}   
            
            return newState;
        }     
        
        case REQUEST_LOANS_REMOVE: {

            let newState = 
            {...state, 
                isFetching: true,
                report: {...state.report},
                loans: [...state.loans]}

            return newState;
        }

        case RECEIVE_LOANS_REMOVE_SUCCESS: {

            let ind = state.loans.findIndex(x => x.id === action.id.id);
            if (ind < 0) 
                return {};

            var newState = 

            {...state,
                isFetching: false,
                report: {...state.report},
                loans: [...state.loans.slice(0, ind),
                    ...state.loans.slice(ind + 1)]}

            return newState;
        }

        default: {
            return state;
        }
    }
}
